export enum ItemHistoryTypeEnum {
  Registered = 'registered',
  Updated = 'updated',
  Verified = 'verified',
  Auctioned = 'auctioned',
  Sold = 'sold',
}
